import { render, staticRenderFns } from "./ScreenChargesList.vue?vue&type=template&id=1bd92790&scoped=true&"
import script from "./ScreenChargesList.vue?vue&type=script&lang=js&"
export * from "./ScreenChargesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd92790",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VDataTable,VDivider,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd92790')) {
      api.createRecord('1bd92790', component.options)
    } else {
      api.reload('1bd92790', component.options)
    }
    module.hot.accept("./ScreenChargesList.vue?vue&type=template&id=1bd92790&scoped=true&", function () {
      api.rerender('1bd92790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Search/ScreenChargesList.vue"
export default component.exports